export enum FishingCardControlName {
  BirthPlace = 'birthPlace',
  BirthDate = 'birthDate',
  ProxyDetailsCheckbox = 'proxyDetailsCheckbox',
  ProxyDetails = 'proxyDetails',
  InvestorDetails = 'investorDetails',
  DecisionForm = 'decisionForm',
  ShippingForm = 'shippingForm'
}
